import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export default function PartnerInviteOverlay({ open, phase = 'loading', onDismiss }) {
  const [mounted, setMounted] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (!open) {
      setMounted(false);
      setShowSuccess(false);
      return undefined;
    }
    setMounted(true);
    if (phase === 'loading') {
      setShowSuccess(false);
    }
    return undefined;
  }, [open, phase]);

  useEffect(() => {
    if (!open || phase !== 'success') return undefined;
    const revealTimer = window.setTimeout(() => setShowSuccess(true), 80);
    const dismissTimer = window.setTimeout(() => onDismiss?.(), 3000);
    return () => {
      window.clearTimeout(revealTimer);
      window.clearTimeout(dismissTimer);
    };
  }, [open, phase, onDismiss]);

  if (!open && !mounted) return null;

  return (
    <div
      className={`fixed inset-0 z-[2000] flex items-center justify-center bg-gray-900/45 p-4 backdrop-blur-sm transition-opacity duration-300 ${
        open ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
      role="dialog"
      aria-modal="true"
      aria-live="polite"
      aria-busy={phase === 'loading'}
    >
      <div
        className={`w-full max-w-sm rounded-2xl bg-white px-8 py-10 text-center shadow-2xl transition-all duration-500 ease-out ${
          open ? 'scale-100 opacity-100 translate-y-0' : 'scale-95 opacity-0 translate-y-2'
        }`}
      >
        {phase === 'loading' ? (
          <div className="flex flex-col items-center gap-4">
            <Spin size="large" />
            <p className="text-sm font-medium text-gray-600">Sending invite link…</p>
          </div>
        ) : (
          <div
            className={`flex flex-col items-center transition-all duration-500 ease-out ${
              showSuccess ? 'scale-100 opacity-100 translate-y-0' : 'scale-90 opacity-0 translate-y-2'
            }`}
          >
            <span
              className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-[0_4px_14px_rgba(33,181,70,0.35)]"
              aria-hidden
            >
              <CheckOutlined style={{ fontSize: 26, fontWeight: 700 }} />
            </span>
            <h3 className="mt-4 text-lg font-semibold text-gray-900">Email sent</h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-500">
              Email sent to user for resetting his password.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
